import { useCallback } from "react";
import { useChartConfigurationAuthorizationQuery } from "src/graphql";

export function useChartConfigurePermission(): {
  modelIds: string[];
  modelFilter: (id: string | number) => boolean;
} {
  const { data: authorizationRows, isLoading } =
    useChartConfigurationAuthorizationQuery(undefined, {
      select: (data) => data.user_group_audience_creation_authorization ?? [],
      meta: { isFastEndpoint: true },
    });

  const modelFilter = useCallback(
    (id: string | number) => {
      if (isLoading || !authorizationRows) {
        return true;
      }

      return authorizationRows.some(
        (row) => String(row.parent_model_id) === String(id),
      );
    },
    [authorizationRows, isLoading],
  );

  return {
    modelIds:
      authorizationRows?.map((row) => row.parent_model_id.toString()) ?? [],
    modelFilter,
  };
}
